<form [formGroup]="usRolesForm" class="example-form settings-form">

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.settingForm.title' | translate}}</mat-label>
        <input formControlName="title" matInput type="text" required>
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.userRolesForm.appAccess' | translate}}</mat-label>
        <mat-select formControlName="appAccess" multiple>
          @for (access of appAccessList; track access) {
            <mat-option [value]="access.type">{{access.translate | translate}}</mat-option>
          }
        </mat-select>
    </mat-form-field>

    <span>{{'FORM.userRolesForm.dataAccess' | translate}} </span>
    <ul class="list-group py-1">
        @for (dacc of dataAccessInfo; track dacc; let index = $index;) {
            <li class="list-group-item d-flex flex-row justify-content-between align-items-center" (click)="onEditDataAccess(dacc, index)">
                <div>
                    <span>{{'COCKPIT.OBJECTS.' + dacc?.collection | translate}}</span> <br>
                    @for (r of dacc?.rights; track r;) {
                        <span class="text-muted">{{'user_roles.rights.' + r | translate}}, </span>
                    }
                </div>
                <button mat-icon-button (click)="deleteData(dacc, $index);">
                    <mat-icon>delete</mat-icon>
                </button>
            </li>
        }
    </ul>

    <button class="w-100 second-stt-btn mb-2" mat-button (click)="onCreateDataAccess()"> {{ 'FORM.BTN_CREATE' | translate }} </button>

    <!-- <mat-form-field class="w-100">
        <mat-label>{{'FORM.userRolesForm.rights' | translate}}</mat-label>
        <mat-select formControlName="rights" multiple>
          @for (right of rightsList; track right) {
            <mat-option [value]="right.right">{{right.name | translate}}</mat-option>
          }
        </mat-select>
    </mat-form-field> -->

    <div>
        <button [disabled]="usRolesForm.invalid || updateRight" class="my-4 first-stt-btn w-100" mat-raised-button type="submit" (click)="onSubmit()">
            {{ 'FORM.BTN_SAVE' | translate }}
        </button>

        <button [disabled]="isCreate || deleteRight" class="w-100 second-stt-btn mb-2" style="float:inline-end;" mat-button (click)="onDelete()">
            {{ 'FORM.BTN_DELETE' | translate }}
        </button>
    </div>

</form>